import moment from "moment";
import { cloneDeep } from "lodash";
import { CSVLink } from "react-csv";
import React, { Component } from "react";
import NotificationSystem from "react-notification-system";
import { NOTIFICATION_SYSTEM_STYLE } from "../utils/constants";
import {
  MdKeyboardArrowLeft,
  MdKeyboardArrowRight,
  MdPayment,
} from "react-icons/md";
import {
  Card,
  CardBody,
  CardHeader,
  Label,
  Input,
  Row,
  Col,
  Button,
  Table,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Form,
  FormGroup,
  UncontrolledCollapse,
  CustomInput,
} from "reactstrap";
import Select from "react-select";
import * as Server from "../Server";
import PageSpinner from "../components/PageSpinner";
import Page from "../components/Page";
import { capitalizeFirstLetter } from "../GeneralFunctions";
import { GlobalContext } from "../components/Layout/MainLayout";

class Teams extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      page: 1,
      limit: 10,
      totalPlayers: 0,
      pages: 0,
      Player: {},
      Players: [],
      allCamps: [],
      Camps: [],
      Camp: {},
      campDetail: {},
      campPrice: 0,
      globalSearch: "",
      pageNumbers: [],
      filterCollapse: false,
      paymentConfirmationModal: false,
      fullPayment: true,
      installments: 0,
      installmentDates: [],
      installmentDateShow: false,
      includeDueAmount: false,
      totalPrice: 0,
      quantityField: {},
      quantity: 0,
      useCreditAmount: false,
      cashPayment: true,
      creditAmount: 0,
      dueAmount: 0,
      csvData: [],
      csvHeaders: [],
      creditCards: [],
      allCreditCardOptions: [],
      selectedCreditCard: null,
    };
  }

  componentDidMount() {
    this.setState({ limit: this.context.limit }, () => this.getAllPlayers());
    this.getCamps();
  }

  getAllPlayers = async (event) => {
    if (event) event.preventDefault();
    try {
      this.setState({ showLoader: true });
      let page = this.state.page;
      let pageLimit = this.state.limit;
      let response = await Server.request({
        url: "rushsoccer/getAllPlayers",
        method: "POST",
        data: {
          page,
          pageLimit,
          globalSearch: this.state.globalSearch,
        },
      });
      if (response) {
        this.setState({
          showLoader: false,
          Players: response.players,
          totalPlayers: response.totalPlayers,
          pages: response.pages,
        });
        let pageNumbers = [];
        for (let page = 1; page <= response.pages; page++) {
          pageNumbers.push(page);
        }
        this.setState({ pageNumbers: pageNumbers });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  getCamps = async () => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "camp/web/list",
        method: "GET",
      });
      if (response && response.camps.length > 0) {
        let allCamps = cloneDeep(response.camps);
        let camps = response.camps
          // .filter((camp) => camp.selectedPayment === "fixed")
          .map((camp) => ({
            label: camp.name,
            value: camp._id,
          }));
        this.setState({
          showLoader: false,
          Camps: camps,
          allCamps,
        });
      } else {
        this.setState({ showLoader: false });
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  payForEvent = async () => {
    try {
      let response;
      this.setState({ showLoader: true });
      if (!this.state.Camp.value) throw Error("Select the event");
      if (this.state.cashPayment) {
        response = await Server.request({
          url: "rushsoccer/player/payForEvent",
          method: "POST",
          data: {
            // payForPlayers: true,
            includeDueAmount: this.state.includeDueAmount,
            useCreditAmount: this.state.useCreditAmount,
            note: this.state.notes,
            fullPayment: this.state.fullPayment,
            campId: this.state.Camp.value,
            parentId: this.state.Player._id,
            childId: this.state.Player.child._id,
            installments: this.state.installments,
            installmentDates: this.state.installmentDates,
            installmentDateShow: this.state.installmentDateShow,
            quantity: this.state.quantity,
            paymentDoneFrom: "web",
          },
        });
      } else {
        if (!this.state.selectedCreditCard)
          throw Error("Select the credit card for payment");
        let stripeCard = this.state.creditCards.find(
          (creditCard) =>
            creditCard.paymentMethodId === this.state.selectedCreditCard.value
        );
        if (this.state.fullPayment) {
          response = await Server.request({
            url: "rushsoccer/stripe/pay",
            method: "POST",
            data: {
              // payForPlayers: true,
              includeDueAmount: this.state.includeDueAmount,
              useCreditAmount: this.state.useCreditAmount,
              SPIEvent: false,
              sendEmail: false,
              APIVersion: "v2",
              paymentFor: "child",
              campId: this.state.Camp.value,
              paymentMethodId: stripeCard.paymentMethodId,
              parentId: stripeCard.parentId,
              childId: this.state.Player.child._id,
              notes: this.state.notes,
              quantity: this.state.quantity,
              paymentDoneFrom: "web",
            },
          });
        } else {
          response = await Server.request({
            url: "rushsoccer/stripe/interval/pay",
            method: "POST",
            data: {
              payForPlayers: true,
              includeDueAmount: this.state.includeDueAmount,
              useCreditAmount: this.state.useCreditAmount,
              SPIEvent: false,
              sendEmail: false,
              APIVersion: "v2",
              interval: "month",
              paymentFor: "child",
              campId: this.state.Camp.value,
              paymentMethodId: stripeCard.paymentMethodId,
              parentId: stripeCard.parentId,
              childId: this.state.Player.child._id,
              notes: this.state.notes,
              installments: this.state.installments,
              installmentDates: this.state.installmentDates,
              installmentDateShow: this.state.installmentDateShow,
              quantity: this.state.quantity,
              paymentDoneFrom: "web",
            },
          });
        }
      }
      if (response) {
        this.setState({ showLoader: false, selectedCreditCard: null }, () =>
          this.getAllPlayers()
        );
        this.notificationSystem.addNotification({
          message: response.message,
          level: "success",
        });
        this.toggleCampPaymentConfirmationModal();
      }
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  downloadCSVData = async (campId) => {
    try {
      this.setState({ showLoader: true });
      let response = await Server.request({
        url: "rushsoccer/download/allPlayers",
        method: "GET",
      });
      if (response && response.success) {
        let csvData = response.csvData;
        csvData = csvData.map((data) => {
          if (data.birthday)
            Object.assign(data, {
              birthday: moment.utc(data.birthday).format("MM/DD/YYYY"),
            });
          return data;
        });
        this.setState({
          showLoader: false,
          csvData,
          csvHeaders: response.csvHeaders,
        });
      }
      this.csvLink.link.click();
    } catch (error) {
      this.setState({ showLoader: false });
      this.notificationSystem.addNotification({
        message: error.message,
        level: "error",
      });
    }
  };

  renderPlayerDetailPage = async (childId) => {
    this.props.history.push({
      pathname: "/playerDetail",
      state: { childId },
    });
  };

  toggleCampPaymentConfirmationModal = (Player) => {
    let allCreditCardOptions = Player
      ? Player.allCreditCards.map((creditCard) => ({
          label: `(${creditCard.name})${creditCard.number}`,
          value: creditCard.paymentMethodId,
        }))
      : [];
    this.setState({
      paymentConfirmationModal: !this.state.paymentConfirmationModal,
      Player: Player ? Player : {},
      Camp: {},
      campPrice: 0,
      notes: "",
      installments: 0,
      fullPayment: true,
      cashPayment: true,
      installmentDates: [],
      installmentDateShow: false,
      includeDueAmount: false,
      useCreditAmount: false,
      totalPrice: 0,
      creditCards: Player ? Player.allCreditCards || [] : [],
      allCreditCardOptions,
      selectedCreditCard: null,
    });
  };

  refreshPagination = (page, limit) => {
    this.setState({ page: parseInt(page, 10), limit: limit }, () => {
      this.getAllPlayers();
    });
  };

  handleCampChange = (camp) => {
    if (camp) {
      let selectedCamp = this.state.allCamps.find(
        (allcamp) => allcamp._id === camp.value
      );
      let quantityField = selectedCamp.registerForm
        ? selectedCamp.registerForm[0].fields.find(
            (field) => field._id === "584f8f03-d257-4cf7-b440-9a2a7d730ea3"
          )
        : {};
      let totalPrice = selectedCamp.price;
      let creditAmount = 0;
      let dueAmount = 0;
      if (this.state.Player.child.creditAmountBreakUp.length) {
        let creditAmountBreakUp = this.state.Player.child.creditAmountBreakUp.filter(
          (value) =>
            value.campId === selectedCamp._id ||
            !value.campId ||
            value.campId === ""
        );
        creditAmount = creditAmountBreakUp.reduce((preVal, curVal) => {
          preVal += curVal.amount;
          return preVal;
        }, 0);
      }
      if (this.state.Player.child.dueAmountBreakUp.length) {
        let dueAmountBreakUp = this.state.Player.child.dueAmountBreakUp.filter(
          (value) =>
            value.campId === selectedCamp._id ||
            !value.campId ||
            value.campId === ""
        );
        dueAmount = dueAmountBreakUp.reduce((preVal, curVal) => {
          preVal += curVal.amount;
          return preVal;
        }, 0);
      }
      totalPrice = totalPrice - creditAmount;
      // totalPrice = this.state.includeDueAmount
      //   ? this.state.dueAmount + totalPrice
      //   : totalPrice;
      this.setState({
        totalPrice: totalPrice > 0 ? totalPrice : 0,
        Camp: camp,
        campPrice: selectedCamp.price,
        installments: selectedCamp.installments || 0,
        installmentDates: selectedCamp.installmentDates || [],
        installmentDateShow:
          selectedCamp.installmentDates && selectedCamp.installmentDates.length
            ? true
            : false,
        quantity: 0,
        quantityField: quantityField || {},
        includeDueAmount: false,
        useCreditAmount: true,
        campDetail: selectedCamp,
        creditAmount,
        dueAmount,
      });
    } else {
      this.setState({
        totalPrice: 0,
        Camp: {},
        campPrice: 0,
        installments: 0,
        installmentDates: [],
        installmentDateShow: false,
        includeDueAmount: false,
        useCreditAmount: false,
        quantity: 0,
        quantityField: {},
      });
    }
  };

  installmentDates = (key) => {
    let dates =
      this.state.installmentDates.length > 0 ? this.state.installmentDates : [];
    if (key === "add") {
      if (this.state.installmentDates.length !== this.state.installments) {
        let Start =
          this.state.installmentDates.length === 0
            ? 1
            : this.state.installmentDates.length + 1;
        for (let index = Start; index <= this.state.installments; index++) {
          dates.push({ price: 0, date: "", installmentNumber: index });
        }
      }
    } else if (key === "remove") {
      for (
        let index1 = this.state.installments + 1;
        index1 <= this.state.installmentDates.length;
        index1++
      ) {
        dates = dates.filter((date) => date.installmentNumber !== index1);
      }
    }
    this.setState({ installmentDates: dates });
  };

  getTotalPrice = () => {
    let totalPrice = this.state.installmentDates[0].price;
    if (this.state.includeDueAmount)
      totalPrice = totalPrice + this.state.dueAmount;
    if (this.state.useCreditAmount)
      totalPrice = totalPrice - this.state.creditAmount;
    return totalPrice > 0 ? totalPrice : 0;
  };

  render() {
    return (
      <div>
        <Page
          title={"All Players"}
          breadcrumbs={[{ name: "All Players", active: true }]}
        >
          <PageSpinner showLoader={this.state.showLoader} />
          <Row>
            <Col>
              <Card>
                <CardHeader>
                  <Row>
                    <Col xl={4} lg={12} md={12}>
                      <div className="d-flex">
                        <div sm={4} className="mt-2 pr-2">
                          <Label>Shown</Label>
                        </div>
                        <div sm={4}>
                          <Input
                            type="select"
                            name="pageLimit"
                            value={this.state.limit}
                            onChange={(event) => {
                              this.refreshPagination(1, event.target.value);
                              this.context.updateState({
                                limit: event.target.value,
                              });
                            }}
                          >
                            <option value={10}>10</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                          </Input>
                        </div>
                        <div sm={4} className="mt-2 pl-2">
                          <Label>entries</Label>
                        </div>
                      </div>
                    </Col>
                    <Col xl={4} lg={12} md={12}>
                      <div className="d-flex justify-content-center">
                        <div className="mt-2 pr-2">
                          <Label>
                            Showing{" "}
                            {!this.state.totalPlayers
                              ? 0
                              : this.state.page * this.state.limit -
                                (this.state.limit - 1) +
                                " "}
                            to{" "}
                            {this.state.page * this.state.limit >
                            this.state.totalPlayers
                              ? this.state.totalPlayers
                              : this.state.page * this.state.limit}{" "}
                            of {this.state.totalPlayers}
                          </Label>
                        </div>
                      </div>
                    </Col>
                    <Col xl={4} lg={12} md={12}>
                      <div className="d-flex justify-content-end">
                        <div sm={4} className="pr-2">
                          <Button
                            className="rounded-circle"
                            disabled={this.state.page <= 1}
                            onClick={(event) =>
                              this.refreshPagination(
                                this.state.page - 1,
                                this.state.limit
                              )
                            }
                          >
                            <MdKeyboardArrowLeft size="20px"></MdKeyboardArrowLeft>
                          </Button>
                        </div>
                        <div sm={4}>
                          <Input
                            type="select"
                            value={this.state.page}
                            name="filter"
                            onChange={(event) => {
                              this.refreshPagination(
                                event.target.value,
                                this.state.limit
                              );
                            }}
                          >
                            {this.state.pageNumbers.length !== 0 ? (
                              this.state.pageNumbers.map(
                                (pageNumber, index) => (
                                  <option value={pageNumber} key={index}>
                                    {pageNumber}
                                  </option>
                                )
                              )
                            ) : (
                              <option value={0}>0</option>
                            )}
                          </Input>
                        </div>
                        <div sm={4} className="pl-2">
                          <Button
                            className="rounded-circle"
                            disabled={this.state.page >= this.state.pages}
                            onClick={(event) =>
                              this.refreshPagination(
                                this.state.page + 1,
                                this.state.limit
                              )
                            }
                          >
                            <MdKeyboardArrowRight size="20px"></MdKeyboardArrowRight>
                          </Button>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col xl={12} lg={12} md={12}>
                      <div className="d-flex justify-content-end">
                        <Button
                          id="toggler1"
                          className="mr-2"
                          style={{
                            float: "right",
                            marginBottom: "10px",
                            width: "25%",
                          }}
                          onClick={() => {
                            this.setState({
                              filterCollapse: !this.state.filterCollapse,
                            });
                          }}
                        >
                          Filters
                        </Button>
                        <Button
                          className="mr-1"
                          style={{
                            float: "right",
                            marginBottom: "10px",
                            width: "25%",
                          }}
                          onClick={() => this.downloadCSVData(null)}
                        >
                          Download all players
                        </Button>
                        <CSVLink
                          style={{ textDecoration: "unset" }}
                          filename={`players.csv`}
                          data={this.state.csvData}
                          headers={this.state.csvHeaders}
                          ref={(ref) => {
                            this.csvLink = ref;
                          }}
                        ></CSVLink>
                      </div>
                    </Col>
                  </Row>
                  <UncontrolledCollapse
                    toggler="#toggler1"
                    isOpen={this.state.filterCollapse}
                  >
                    <Card>
                      <CardBody>
                        <Form
                          className="form"
                          onSubmit={(event) => this.getAllPlayers(event)}
                        >
                          <Row>
                            <Col
                              xl={6}
                              lg={12}
                              md={12}
                              style={{ paddingRight: "0px" }}
                            >
                              <FormGroup>
                                <Label for="name">Search</Label>
                                <Input
                                  icon="search"
                                  value={this.state.globalSearch}
                                  placeholder="Search"
                                  onChange={(event) =>
                                    this.setState({
                                      globalSearch: event.target.value,
                                    })
                                  }
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          <Row>
                            <Col xl={6} lg={12} md={12}>
                              <FormGroup>
                                <Button
                                  className="mr-3"
                                  color="primary"
                                  type="submit"
                                >
                                  Filter
                                </Button>
                                <Button
                                  onClick={() =>
                                    this.setState({
                                      globalSearch: "",
                                    })
                                  }
                                >
                                  Reset Filter
                                </Button>
                              </FormGroup>
                            </Col>
                          </Row>
                        </Form>
                      </CardBody>
                    </Card>
                  </UncontrolledCollapse>
                  <Table striped hover responsive>
                    <thead>
                      <tr>
                        <th>Photo</th>
                        <th>FirstName</th>
                        <th>LastName</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.Players && this.state.Players.length > 0 ? (
                        this.state.Players.map((player, index) => (
                          <tr
                            key={index}
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              this.renderPlayerDetailPage(player.child._id)
                            }
                          >
                            <td className=" w-25 h-25">
                              {player.child.data.files &&
                              player.child.data.files.length > 0
                                ? player.child.data.files.map(
                                    (file, index) =>
                                      file.name === "photo" && (
                                        <img
                                          key={index}
                                          src={file.url}
                                          className="img-responsive"
                                          alt=""
                                          style={{ width: "100px" }}
                                        />
                                      )
                                  )
                                : "Not Available"}
                            </td>
                            <td>
                              {capitalizeFirstLetter(
                                player.child.data.firstName || "-"
                              )}
                            </td>
                            <td>
                              {capitalizeFirstLetter(
                                player.child.data.lastName || "-"
                              )}
                            </td>
                            <td className="d-flex">
                              <Button
                                style={{ marginLeft: "10px" }}
                                onClick={(event) => {
                                  event.stopPropagation();
                                  this.toggleCampPaymentConfirmationModal(
                                    player
                                  );
                                }}
                              >
                                <MdPayment size="20px"></MdPayment>
                              </Button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="5" className="text-center">
                            No players found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </CardBody>
                {this.state.paymentConfirmationModal ? (
                  <Modal
                    isOpen={this.state.paymentConfirmationModal}
                    toggle={(event) =>
                      this.toggleCampPaymentConfirmationModal()
                    }
                    className="modal-md"
                  >
                    <ModalHeader
                      toggle={(event) =>
                        this.toggleCampPaymentConfirmationModal()
                      }
                    >
                      Payment for Event
                    </ModalHeader>
                    <ModalBody>
                      <Row>
                        <Col xl={12} lg={12} md={12}>
                          <FormGroup>
                            <Label>Events:</Label>
                            <Select
                              options={this.state.Camps || []}
                              isSearchable={true}
                              isClearable={true}
                              value={this.state.Camp}
                              onChange={this.handleCampChange}
                              className="basic-single"
                              classNamePrefix="select"
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      {this.state.Camp.value &&
                      this.state.campDetail.includeDueAmount ? (
                        <>
                          <Row>
                            <Col xl={12} lg={12} md={12}>
                              <Label>Include any past due amount:</Label>
                            </Col>
                          </Row>
                          <Row>
                            <Col xl={6} lg={6} md={6} sm={6}>
                              <FormGroup>
                                <CustomInput
                                  id="yes"
                                  type="radio"
                                  label="Yes"
                                  checked={this.state.includeDueAmount}
                                  name="includeDueAmount"
                                  onClick={() => {
                                    let totalPrice = this.state.campPrice;
                                    if (this.state.quantity)
                                      totalPrice =
                                        this.state.campPrice *
                                        this.state.quantity;
                                    if (this.state.useCreditAmount)
                                      totalPrice =
                                        totalPrice - this.state.creditAmount;
                                    totalPrice =
                                      totalPrice + this.state.dueAmount;
                                    this.setState({
                                      totalPrice:
                                        totalPrice > 0 ? totalPrice : 0,
                                      includeDueAmount: true,
                                    });
                                  }}
                                />
                              </FormGroup>
                            </Col>
                            <Col xl={6} lg={6} md={6} sm={6}>
                              <FormGroup>
                                <CustomInput
                                  id="no"
                                  type="radio"
                                  label="No"
                                  checked={!this.state.includeDueAmount}
                                  name="includeDueAmount"
                                  onClick={() => {
                                    let totalPrice = this.state.campPrice;
                                    if (this.state.quantity)
                                      totalPrice =
                                        this.state.campPrice *
                                        this.state.quantity;
                                    if (this.state.useCreditAmount)
                                      totalPrice =
                                        totalPrice - this.state.creditAmount;
                                    this.setState({
                                      totalPrice:
                                        totalPrice > 0 ? totalPrice : 0,
                                      includeDueAmount: false,
                                    });
                                  }}
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                        </>
                      ) : null}
                      {this.state.Camp.value &&
                      this.state.campDetail.useCreditAmount ? (
                        <>
                          <Row>
                            <Col xl={12} lg={12} md={12}>
                              <Label>Use credit amount:</Label>
                            </Col>
                          </Row>
                          <Row>
                            <Col xl={6} lg={6} md={6} sm={6}>
                              <FormGroup>
                                <CustomInput
                                  id="yes1"
                                  type="radio"
                                  label="Yes"
                                  checked={this.state.useCreditAmount}
                                  name="useCreditAmount"
                                  onClick={() => {
                                    let totalPrice = this.state.campPrice;
                                    if (this.state.quantity)
                                      totalPrice =
                                        this.state.campPrice *
                                        this.state.quantity;
                                    if (this.state.includeDueAmount)
                                      totalPrice =
                                        totalPrice + this.state.dueAmount;
                                    totalPrice =
                                      totalPrice - this.state.creditAmount;
                                    this.setState({
                                      totalPrice:
                                        totalPrice > 0 ? totalPrice : 0,
                                      useCreditAmount: true,
                                    });
                                  }}
                                />
                              </FormGroup>
                            </Col>
                            <Col xl={6} lg={6} md={6} sm={6}>
                              <FormGroup>
                                <CustomInput
                                  id="no1"
                                  type="radio"
                                  label="No"
                                  checked={!this.state.useCreditAmount}
                                  name="useCreditAmount"
                                  onClick={() => {
                                    let totalPrice = this.state.campPrice;
                                    if (this.state.quantity)
                                      totalPrice =
                                        this.state.campPrice *
                                        this.state.quantity;
                                    if (this.state.includeDueAmount)
                                      totalPrice =
                                        totalPrice + this.state.dueAmount;
                                    this.setState({
                                      totalPrice:
                                        totalPrice > 0 ? totalPrice : 0,
                                      useCreditAmount: false,
                                    });
                                  }}
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                        </>
                      ) : null}
                      {this.state.quantityField.hasOwnProperty(
                        "placeholder"
                      ) ? (
                        <Row>
                          <Col xl={12} lg={12} md={12}>
                            <FormGroup>
                              <Label>
                                {this.state.quantityField.placeholder}
                              </Label>
                              <Input
                                type="select"
                                name={this.state.quantityField.name}
                                value={this.state.quantity || "default"}
                                onChange={(event) => {
                                  let totalPrice =
                                    this.state.campPrice * event.target.value;
                                  totalPrice = this.state.includeDueAmount
                                    ? this.state.dueAmount + totalPrice
                                    : totalPrice;
                                  totalPrice = this.state.useCreditAmount
                                    ? totalPrice - this.state.creditAmount
                                    : totalPrice;
                                  this.setState({
                                    quantity: event.target.value,
                                    totalPrice: totalPrice > 0 ? totalPrice : 0,
                                  });
                                }}
                              >
                                <option value="default" disabled>
                                  Select the value
                                </option>
                                {this.state.quantityField.values &&
                                  this.state.quantityField.values.length &&
                                  this.state.quantityField.values.map(
                                    (value, index) => (
                                      <option key={index} value={value}>
                                        {value}
                                      </option>
                                    )
                                  )}
                              </Input>
                            </FormGroup>
                          </Col>
                        </Row>
                      ) : null}
                      <Row>
                        <Col xl={12} lg={12} md={12}>
                          <FormGroup>
                            <Label>Event Price</Label>
                            <Input
                              disabled
                              type="text"
                              value={this.state.campPrice}
                            ></Input>
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col xl={12} lg={12} md={12}>
                          <FormGroup>
                            <Label>Total Price</Label>
                            <Input
                              disabled
                              type="text"
                              value={this.state.totalPrice}
                            ></Input>
                          </FormGroup>
                        </Col>
                      </Row>

                      <Row>
                        <Col xl={12} lg={12} md={12}>
                          <FormGroup>
                            <Label>Add Note</Label>
                            <Input
                              required
                              type="text"
                              placeholder="Payment done by admin"
                              value={this.state.notes}
                              onChange={(event) => {
                                event.persist();
                                this.setState({
                                  notes: event.target.value,
                                });
                              }}
                            ></Input>
                          </FormGroup>
                        </Col>
                      </Row>
                      {this.state.Camp.value && (
                        <>
                          <Row>
                            <Col xl={6} lg={6} md={6} sm={6}>
                              <FormGroup>
                                <CustomInput
                                  id="cashpayment"
                                  type="radio"
                                  label="Cash Payment"
                                  checked={this.state.cashPayment}
                                  name="payment1"
                                  onClick={() =>
                                    this.setState({
                                      cashPayment: true,
                                    })
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col xl={6} lg={6} md={6} sm={6}>
                              <FormGroup>
                                <CustomInput
                                  id="cardpayment"
                                  type="radio"
                                  label="Credit card payment"
                                  checked={!this.state.cashPayment}
                                  name="payment1"
                                  onClick={() =>
                                    this.setState({
                                      cashPayment: false,
                                    })
                                  }
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          {!this.state.cashPayment ? (
                            <Row>
                              <Col xl={12} lg={12} md={12}>
                                <FormGroup>
                                  <Label>Select Credit Card</Label>
                                  <Select
                                    placeholder="Select the credit card"
                                    value={this.state.selectedCreditCard}
                                    options={this.state.allCreditCardOptions}
                                    onChange={(result) =>
                                      this.setState({
                                        selectedCreditCard: result,
                                      })
                                    }
                                  />
                                </FormGroup>
                              </Col>
                            </Row>
                          ) : null}
                          <Row>
                            <Col xl={6} lg={6} md={6} sm={6}>
                              <FormGroup>
                                <CustomInput
                                  id="fullpayment"
                                  type="radio"
                                  label="Full Payment"
                                  checked={this.state.fullPayment}
                                  name="payment"
                                  onClick={() =>
                                    this.setState({
                                      fullPayment: true,
                                    })
                                  }
                                />
                              </FormGroup>
                            </Col>
                            <Col xl={6} lg={6} md={6} sm={6}>
                              <FormGroup>
                                <CustomInput
                                  id="installmentpayment"
                                  type="radio"
                                  label="Installment payment"
                                  checked={!this.state.fullPayment}
                                  name="payment"
                                  onClick={() =>
                                    this.setState({
                                      fullPayment: false,
                                    })
                                  }
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                        </>
                      )}
                      {!this.state.fullPayment && (
                        <>
                          <Row>
                            <Col xl={12} lg={12} md={12} sm={12}>
                              <FormGroup>
                                <Label for="installments">
                                  Select Installments :
                                </Label>
                                <CustomInput
                                  type="select"
                                  id="installments"
                                  name="selectInstallments"
                                  defaultValue={"0"}
                                  value={this.state.installments}
                                  onChange={(event) => {
                                    event.persist();
                                    let key =
                                      event.target.value >
                                      parseInt(this.state.installments || 0)
                                        ? "add"
                                        : "remove";
                                    this.setState(
                                      {
                                        installments: Number(
                                          event.target.value
                                        ),
                                      },
                                      () => this.installmentDates(key)
                                    );
                                  }}
                                >
                                  <option value="0" disabled>
                                    Select the value
                                  </option>
                                  <option value="2">2</option>
                                  <option value="3">3</option>
                                  <option value="4">4</option>
                                  <option value="5">5</option>
                                  <option value="6">6</option>
                                  <option value="7">7</option>
                                  <option value="8">8</option>
                                  <option value="9">9</option>
                                  <option value="10">10</option>
                                  <option value="11">11</option>
                                </CustomInput>
                              </FormGroup>
                            </Col>
                          </Row>
                          {this.state.installments ? (
                            <Row>
                              <Col xl={12} lg={12} md={12} sm={12}>
                                <div className="ml-4">
                                  <Input
                                    type="checkbox"
                                    style={{ width: "15px", height: "15px" }}
                                    checked={this.state.installmentDateShow}
                                    onChange={async (event) => {
                                      this.setState(
                                        {
                                          installmentDateShow: !this.state
                                            .installmentDateShow,
                                        },
                                        () => {
                                          this.state.installmentDateShow ===
                                            true &&
                                            this.installmentDates("add");
                                        }
                                      );
                                    }}
                                  ></Input>
                                  <Label>Set Custom Installment Dates</Label>
                                </div>
                              </Col>
                            </Row>
                          ) : null}
                          {this.state.installmentDateShow && (
                            <Row>
                              <Col xl={12} lg={12} md={12} sm={12}>
                                <Label>Installment Dates :</Label>
                                {this.state.installmentDates &&
                                this.state.installmentDates.length > 0
                                  ? this.state.installmentDates.map(
                                      (installmentDate, index) => (
                                        <div className="mt-2 mb-3" key={index}>
                                          {index === 0 ? (
                                            <>
                                              <Label>
                                                Payment {index} :
                                                {this.state.cashPayment
                                                  ? " (Payment using cash)"
                                                  : " (Payment using credit card)"}
                                              </Label>
                                              <Input
                                                type="number"
                                                min="0"
                                                required={
                                                  this.state.installmentDateShow
                                                }
                                                value={installmentDate.price}
                                                onChange={(event) => {
                                                  // let camp =
                                                  this.state.allCamps.find(
                                                    (camp) =>
                                                      camp._id ===
                                                      this.state.Camp.value
                                                  );
                                                  // if (
                                                  //   event.target.value >= 0 &&
                                                  //   event.target.value <=
                                                  //   camp.price
                                                  // ) {
                                                  let installmentDates = cloneDeep(
                                                    this.state.installmentDates
                                                  );
                                                  installmentDates[
                                                    index
                                                  ].price = Number(
                                                    event.target.value
                                                  );
                                                  this.setState({
                                                    installmentDates: installmentDates,
                                                  });
                                                  // }
                                                }}
                                              ></Input>
                                              {this.state.includeDueAmount ? (
                                                <div className="mt-2 mb-3">
                                                  <Label>Due Amount :</Label>
                                                  <Input
                                                    type="number"
                                                    disabled
                                                    value={this.state.dueAmount}
                                                  ></Input>
                                                </div>
                                              ) : null}
                                              {this.state.useCreditAmount ? (
                                                <div className="mt-2 mb-3">
                                                  <Label>Credit Amount :</Label>
                                                  <Input
                                                    type="number"
                                                    disabled
                                                    value={
                                                      this.state.creditAmount
                                                    }
                                                  ></Input>
                                                </div>
                                              ) : null}
                                              {this.state.includeDueAmount ||
                                              this.state.useCreditAmount ? (
                                                <div className="mt-2 mb-3">
                                                  <Label>Total Price :</Label>
                                                  <Input
                                                    type="number"
                                                    disabled
                                                    value={this.getTotalPrice()}
                                                  ></Input>
                                                </div>
                                              ) : null}
                                            </>
                                          ) : (
                                            <>
                                              <Label>
                                                Payment {index} : (Payment using
                                                credit card)
                                              </Label>
                                              <Input
                                                type="date"
                                                value={
                                                  moment(
                                                    new Date(
                                                      installmentDate.date
                                                    )
                                                  ).format("YYYY-MM-DD") || ""
                                                }
                                                onChange={(event) => {
                                                  let dates = this.state
                                                    .installmentDates;
                                                  let date = new Date(
                                                    event.target.value
                                                  ).setUTCHours(12);
                                                  dates[index].date = date;
                                                  this.setState({
                                                    installmentDates: dates,
                                                  });
                                                }}
                                                required={
                                                  this.state.installmentDateShow
                                                }
                                              ></Input>
                                            </>
                                          )}
                                        </div>
                                      )
                                    )
                                  : null}
                              </Col>
                            </Row>
                          )}
                        </>
                      )}
                    </ModalBody>
                    <ModalFooter>
                      <Button
                        color="secondary"
                        onClick={(event) =>
                          this.toggleCampPaymentConfirmationModal()
                        }
                      >
                        Cancel
                      </Button>
                      <Button
                        color="primary"
                        onClick={(event) => {
                          this.payForEvent();
                        }}
                      >
                        Pay
                      </Button>
                    </ModalFooter>
                  </Modal>
                ) : null}
              </Card>
            </Col>
          </Row>
          <NotificationSystem
            dismissible={false}
            ref={(notificationSystem) =>
              (this.notificationSystem = notificationSystem)
            }
            style={NOTIFICATION_SYSTEM_STYLE}
          />
        </Page>
      </div>
    );
  }
}
Teams.contextType = GlobalContext;
export default Teams;
